import { TERMINALS_FETCHING_CHANGED, TERMINALS_LIST_CHANGED } from './types';
import agentService from '../../services/AgentService';

export const setTerminalsLoading = isFetching => ({
    type: TERMINALS_FETCHING_CHANGED,
    payload: isFetching,
});

export const setTerminalsList = payload => ({
    type: TERMINALS_LIST_CHANGED,
    payload,
});

export const getTerminals = () => async dispatch => {
    dispatch(setTerminalsLoading(true));
    const { info, items } = await agentService.getTerminals();

    if (!info.success) {
        setTerminalsLoading(false);
        return;
    }

    dispatch(setTerminalsList(items));
    dispatch(setTerminalsLoading(false));
};
